import React, { useState } from 'react';

type Props = {
    children: React.ReactNode[] | React.ReactNode;
    header?: string;
    defaultOpen?: boolean;
};

export function TabSection({ children, header, defaultOpen = true }: Readonly<Props>) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <section className="mv-tab-section">
            {header ? (
                <h3
                    className={`mv-tab-section-header mv-tab-section-header--collapsible`}
                    onClick={() => setIsOpen(o => !o)}
                    aria-expanded={isOpen}
                >
                    {header}
                    <span className={`mv-tab-section-chevron${isOpen ? ' mv-tab-section-chevron--open' : ''}`} />
                </h3>
            ) : null}
            {isOpen && (
                <div className="mv-tab-section-body">
                    {React.Children.map(children, child =>
                        React.isValidElement(child) ? React.cloneElement(child) : child
                    )}
                </div>
            )}
        </section>
    );
}
